import Util from './libs/util';

const util = new Util();

export default class effectManager {
    constructor(){
    }
    show($target,type,delay){

        switch (type){
            case "set":

                for( let n in $target ){
                    if($target[n].nodeType!=1) continue; // dom要素以外は処理止める
                    if($target[n].classList.contains("dir-x")){
                        TweenMax.set($target[n],{ opacity:0, x:-100});
                    }else{
                        TweenMax.set($target[n],{ opacity:0, y:-100});
                    }
                }

                break;
            case "show":


                TweenMax.staggerTo($target,0.9, {
                    y:0,
                    x:0,
                    opacity:1,
                    // scale:1,
                    ease: "Power2.easeOut",
                    delay:delay
                },0.1);
                break;
            case "out":
                for( let n in $target ){
                    if($target[n].nodeType!=1) continue; // dom要素以外は処理止める
                    if($target[n].classList.contains("dir-x")){
                        TweenMax.to($target[n],0.6, {
                            x:-100,
                            opacity:0,
                            // scale:1,
                            ease: "Power2.easeOut",
                        });
                    }else{
                        TweenMax.to($target[n],0.6, {
                            y:-100,
                            opacity:0,
                            // scale:1,
                            ease: "Power2.easeOut",
                        });
                    }
                }


                // TweenMax.to($target,0.6, {
                //     y:-100,
                //     opacity:0,
                //     // scale:1,
                //     ease: "Power2.easeOut",
                // });
                break;
            case "out2":
                for( let n in $target ){
                    if($target[n].nodeType!=1) continue; // dom要素以外は処理止める
                    if($target[n].classList.contains("dir-x")){
                        TweenMax.to($target[n],0.6, {
                            x:-100,
                            opacity:0,
                            // scale:1,
                            ease: "Power2.easeOut",
                            delay:0.05*n
                        });
                    }else{
                        TweenMax.to($target[n],0.6, {
                            y:-100,
                            opacity:0,
                            // scale:1,
                            ease: "Power2.easeOut",
                            delay:0.05*n
                        });
                    }
                }

                break;
        }

    }
    showSimple($target,type){

        switch (type){
            case "set":

                for( let n in $target ){
                    if($target[n].nodeType!=1) continue; // dom要素以外は処理止める
                    TweenMax.set($target[n],{ opacity:0});
                }

                break;
            case "show":


                TweenMax.staggerTo($target,0.9, {
                    opacity:1,
                    // scale:1,
                    ease: "Power2.easeOut",
                },0.1);
                break;
            case "out":
                TweenMax.staggerTo($target,0.9, {
                    opacity:0,
                    // scale:1,
                    ease: "Power2.easeOut",
                },0.1);

                break;
        }

    }
    svg($target,type){
        switch (type){
            case "set":
                TweenLite.set($target.getElementsByClassName("js__write"), {drawSVG: "0%"});
                break;
            case "show":
                TweenMax.staggerTo($target.getElementsByClassName("js__write"), 1.8, {
                    drawSVG: "100%",
                    ease: Expo.easeIn
                    // ease: SlowMo.ease.config(0.1, 1.2, false)
                    // ease: Power2.easeOut,
                }, .03);
                break;
            case "out":
                TweenMax.staggerTo($target.getElementsByClassName("js__write"), 0.3, {
                    drawSVG: "0%",
                    ease: Power2.easeOut,
                }, .05);
                break;
        }
    }
    svgGlitch($target,type,$split,$show){

        if(!$target) return;
        
        switch (type){
            case "set":

                console.log($target.classList,$target.classList.contains("is-set"))

                if($target.classList.contains("is-set")) return;
                $target.classList.add("is-set");

                let _$id = $target.getAttribute("id");
                let _$p;

                for( let i in $target.querySelectorAll(".js__svg") ){
                    _$p = $target.querySelectorAll(".js__svg")[i];
                    if(_$p.nodeType!=1) continue; // dom要素以外は処理止める
                    let _$t = _$p.getElementsByClassName("js__write");

                    if(!_$p.classList.contains("is-clone-comp")){
                        for( let n in _$t ){
                            if(_$t[n].nodeType!=1) continue; // dom要素以外は処理止める
                            let _childID = _$id+n+'_'+i;
                            _$t[n].setAttribute("id",_childID); // idを個別に付与してクローンの準備
                            _$t[n].classList.add("js__ph1");
                            let _$c = document.getElementById(_childID).cloneNode(true);
                            _$c.classList.remove("js__ph1");//クローンした要素のclassは別のものに振り替える
                            _$c.classList.add("js__ph2");
                            _$c.classList.add("js__m-fit");
                            _$c.setAttribute("id",_childID+'_'+i+'_2'); //クローンした要素のidを固有にアップデート
                            _$p.appendChild(_$c);
                        }
                    }

                    _$p.classList.add("is-clone-comp");

                    TweenLite.set($target.getElementsByClassName("js__write"), {drawSVG: "0%",scaleX:1.2});

                    let _$p1 = $target.getElementsByClassName('js__ph1');
                    for( let n in _$p1 ){
                        if(_$p1[n].nodeType!=1) continue; // dom要素以外は処理止める
                        TweenLite.set(_$p1[n], {x:Math.floor(util.random(-30,30)),y:Math.floor(util.random(-30,30))});
                    }
                }


                break;
            case "show":


                TweenMax.staggerTo($target.getElementsByClassName("js__ph1"), 1.8, {
                    drawSVG: "100%",
                    scaleX:1,
                    x:0,
                    y:0,
                    ease: Expo.easeIn
                    // ease: SlowMo.ease.config(0.1, 1.2, false)
                    // ease: Power2.easeOut,
                }, .03,()=>{
                    if($show[0])this.showSimple($show,"show",0);
                    if($split[0])this.splitTextSimple($split,"show",0);
                });
                // setTimeout(()=>{
                // },1e3)
                // TweenMax.staggerTo($target.getElementsByClassName("js__ph1"), 1.2, {
                //     x:0,
                //     y:0,
                //     delay:1.3,
                //     ease: Power2.easeOut
                //     // ease: SlowMo.ease.config(0.1, 1.2, false)
                //     // ease: Power2.easeOut,
                // }, .03);

                TweenMax.staggerTo($target.getElementsByClassName("js__ph2"), 1.8, {
                    drawSVG: "100%",
                    scaleX:1,
                    delay:0.8,
                    ease: Expo.easeInOut
                    // ease: SlowMo.ease.config(0.1, 1.2, false)
                    // ease: Power2.easeOut,
                }, .03);
                break;

            case "out":
                TweenMax.killChildTweensOf($target,{drawSVG:true,scaleX:true,x:true,y:true});
                TweenMax.to([$target.getElementsByClassName("js__ph1"),$target.getElementsByClassName("js__ph2")], 0.9, {
                    drawSVG: "0%",
                    scaleX:1.2,
                    ease: Expo.easeIn,
                    onComplete:()=>{
                        for(let n in $target.getElementsByClassName("js__ph1")){
                            if($target.getElementsByClassName("js__ph1")[n].nodeType!=1) continue; // dom要素以外は処理止める
                            TweenMax.set($target.getElementsByClassName("js__ph1")[n], {
                                x:Math.floor(util.random(-30,30)),
                                y:Math.floor(util.random(-30,30)),
                            });

                        }
                    }
                    // ease: SlowMo.ease.config(0.1, 1.2, false)
                    // ease: Power2.easeOut,
                });

                // TweenMax.staggerTo($target.getElementsByClassName("js__ph2"), 0.9, {
                //     drawSVG: "0%",
                //     scaleX:1.2,
                //     delay:0.4,
                //     ease: Expo.easeInOut
                //     // ease: SlowMo.ease.config(0.1, 1.2, false)
                //     // ease: Power2.easeOut,
                // }, .03);
                break;
            case "setout":
                TweenMax.killChildTweensOf($target,{drawSVG:true,scaleX:true,x:true,y:true});
                TweenMax.set($target.getElementsByClassName("js__ph2"), {
                    drawSVG: "0%",
                    scaleX:1.2,
                });
                for(let n in $target.getElementsByClassName("js__ph1")){
                    if($target.getElementsByClassName("js__ph1")[n].nodeType!=1) continue; // dom要素以外は処理止める
                    TweenMax.set($target.getElementsByClassName("js__ph1")[n], {
                        drawSVG: "0%",
                        scaleX:1.2,
                        x:Math.floor(util.random(-30,30)),
                        y:Math.floor(util.random(-30,30)),
                    });

                }

                break;
        }
    }
    svgGlitchSimple($target,type,$split,$show){

        if(!$target) return;

        switch (type){
            case "set":
                if($target.classList.contains("is-set")) return;
                $target.classList.add("is-set");

                let _$id = $target.getAttribute("id");
                let _$p;

                for( let i in $target.querySelectorAll(".js__svg") ){
                    _$p = $target.querySelectorAll(".js__svg")[i];
                    if(_$p.nodeType!=1) continue; // dom要素以外は処理止める
                    let _$t = _$p.getElementsByClassName("js__write");

                    if(!_$p.classList.contains("is-clone-comp")){
                        for( let n in _$t ){
                            if(_$t[n].nodeType!=1) continue; // dom要素以外は処理止める
                            let _childID = _$id+n+'_'+i;
                            _$t[n].setAttribute("id",_childID); // idを個別に付与してクローンの準備
                            _$t[n].classList.add("js__ph1");
                            let _$c = document.getElementById(_childID).cloneNode(true);
                            _$c.classList.remove("js__ph1");//クローンした要素のclassは別のものに振り替える
                            _$c.classList.add("js__ph2");
                            _$c.classList.add("js__m-fit");
                            _$c.setAttribute("id",_childID+'_'+i+'_2'); //クローンした要素のidを固有にアップデート
                            _$p.appendChild(_$c);
                        }
                    }

                    _$p.classList.add("is-clone-comp");

                    TweenLite.set($target.getElementsByClassName("js__write"), {drawSVG: "0%",scaleX:1.2});

                    let _$p1 = $target.getElementsByClassName('js__ph1');
                    for( let n in _$p1 ){
                        if(_$p1[n].nodeType!=1) continue; // dom要素以外は処理止める
                        TweenLite.set(_$p1[n], {x:Math.floor(util.random(-30,30)),y:Math.floor(util.random(-30,30))});
                    }
                }


                break;
            case "show":

                TweenMax.staggerTo($target.getElementsByClassName("js__ph1"), 1.8, {
                    drawSVG: "100%",
                    scaleX:1,
                    x:0,
                    y:0,
                    ease: Expo.easeOut
                    // ease: SlowMo.ease.config(0.1, 1.2, false)
                    // ease: Power2.easeOut,
                }, .03,()=>{
                });
                TweenMax.staggerTo($target.getElementsByClassName("js__ph2"), 1.8, {
                    drawSVG: "100%",
                    scaleX:1,
                    delay:0.2,
                    ease: Expo.easeOut
                    // ease: SlowMo.ease.config(0.1, 1.2, false)
                    // ease: Power2.easeOut,
                }, .03);
                break;

            case "out":
                TweenMax.killChildTweensOf($target,{drawSVG:true,scaleX:true,x:true,y:true});
                TweenMax.to([$target.getElementsByClassName("js__ph1"),$target.getElementsByClassName("js__ph2")], 0.6, {
                    drawSVG: "0%",
                    scaleX:1.2,
                    ease: Expo.easeOut,
                    onComplete:()=>{
                        for(let n in $target.getElementsByClassName("js__ph1")){
                            if($target.getElementsByClassName("js__ph1")[n].nodeType!=1) continue; // dom要素以外は処理止める
                            TweenMax.set($target.getElementsByClassName("js__ph1")[n], {
                                x:Math.floor(util.random(-30,30)),
                                y:Math.floor(util.random(-30,30)),
                            });

                        }
                    }
                    // ease: SlowMo.ease.config(0.1, 1.2, false)
                    // ease: Power2.easeOut,
                });

                // TweenMax.staggerTo($target.getElementsByClassName("js__ph2"), 0.9, {
                //     drawSVG: "0%",
                //     scaleX:1.2,
                //     delay:0.4,
                //     ease: Expo.easeInOut
                //     // ease: SlowMo.ease.config(0.1, 1.2, false)
                //     // ease: Power2.easeOut,
                // }, .03);
                break;
            case "setout":
                TweenMax.killChildTweensOf($target,{drawSVG:true,scaleX:true,x:true,y:true});
                TweenMax.set($target.getElementsByClassName("js__ph2"), {
                    drawSVG: "0%",
                    scaleX:1.2,
                });
                for(let n in $target.getElementsByClassName("js__ph1")){
                    if($target.getElementsByClassName("js__ph1")[n].nodeType!=1) continue; // dom要素以外は処理止める
                    TweenMax.set($target.getElementsByClassName("js__ph1")[n], {
                        drawSVG: "0%",
                        scaleX:1.2,
                        x:Math.floor(util.random(-30,30)),
                        y:Math.floor(util.random(-30,30)),
                    });

                }

                break;
        }
    }

    splitText($target,type,delay){

        switch (type){
            case "set":

                let chars;

                for( let n in $target ) {
                    if ($target[n].nodeType != 1) continue; // dom要素以外は処理止める

                    let text = new SplitText($target[n], {type:"words,chars"});
                    chars = text.chars;

                    for( let n in chars ) {
                        TweenMax.set(chars[n],{ opacity:0, x:Math.floor(util.random(-30,30)),y:Math.floor(util.random(-30,30))});
                    }


                }

                break;
            case "show":


                for( let n in $target ) {
                    if ($target[n].nodeType != 1) continue; // dom要素以外は処理止める
                    TweenMax.to($target[n],1.8,{
                        opacity:1,
                        // scale:1,
                        x:0,
                        y:0,
                        delay:delay + Math.floor(util.random(0,1)*10)/10
                    });
                }

                break;
            case "out":
                TweenMax.to($target, 0.4,
                    {
                        opacity:0,
                        // filter:"blur(0px)",
                        ease: "Power2.easeIn",
                        onComplete:()=>{
                            for( let n in $target ) {
                                if($target[n].nodeType!=1) continue; // dom要素以外は処理止める
                                TweenMax.set($target[n],{x:Math.floor(util.random(-30,30)),y:Math.floor(util.random(-30,30))});
                            }
                        }
                    });
                break;
        }

    }
    splitTextSimple($target,type){

        switch (type){
            case "set":

                let chars;

                for( let n in $target ) {
                    if ($target[n].nodeType != 1) continue; // dom要素以外は処理止める

                    let text = new SplitText($target[n], {type:"words,chars"});
                    chars = text.chars;

                    TweenMax.set(chars,{ opacity:0});


                }

                break;
            case "show":


                for( let n in $target ) {
                    if ($target[n].nodeType != 1) continue; // dom要素以外は処理止める
                    TweenMax.to($target[n],1.8,{
                        opacity:1,
                        // scale:1,
                        // x:0,
                        // y:0,
                        delay:Math.floor(util.random(0,0.5)*10)/10
                    });
                }

                break;
            case "out":
                TweenMax.staggerTo($target, 0.4,
                    {
                        opacity:0,
                        // filter:"blur(0px)",
                        ease: "Power2.easeIn",
                    },
                    0.01,()=>{
                    }
                );
                break;
        }

    }
    panel($target,type){

        switch (type){
            case "set":

                for( let n in $target ){
                    if($target[n].nodeType!=1) continue; // dom要素以外は処理止める
                    if($target[n].classList.contains("dir-x")){
                        TweenMax.set($target[n],{x:-101+"%"});
                    }else{
                        TweenMax.set($target[n],{ y:-101+"%"});
                    }
                }


                break;
            case "show":


                TweenMax.staggerTo($target,0.9, {
                    x:0+"%",
                    y:0+"%",
                    // scale:1,
                    ease: "Power2.easeOut",
                },0.1);
                break;
            case "out":
                TweenMax.to($target,0.9, {
                    x:101+"%",
                    // scale:1,
                    ease: "Power2.easeOut",
                });

                break;
        }

    }

}
